import React, { useState, useEffect, useRef } from 'react'

const componentStyles = {
    root: {
        display: 'flex',
        flexDirection: 'column',
    }
}

export default function RStack(props) {
    const {
        ref,
        size,
        grow = 0,
        styles = {},
        stackRef,
        children,
    } = props

    const rootStyle = {
        ...componentStyles.root, 
        flexDirection: size === 'small' ? 'column' : 'row',
        flexGrow: grow,
        ...styles.root,
    }

    return (
        <div ref={stackRef} style={rootStyle}>
            {children}
        </div>
    )
}